<template>
  <div class="row mx-0 mb-3">
    <div class="col-12 mb-2 bold">
      {{ title }}
    </div>
    <div class="col-12">
      <textarea v-model="content" class="form-control w-100" rows="4" v-if="multiline" @input="handleInput"></textarea>
      <input type="text" v-model="content" class="form-control w-100" @input="handleInput" v-else>
    </div>
  </div>
</template>
<script>
export default {
  props: ['value', 'title', 'multiline'],
  data () {
    return {
      content: this.value
    }
  },
  methods: {
    handleInput (e) {
      this.$emit('input', this.content)
    }
  }
}
</script>
